/**
 * Header search with suggestions panel (souman-agro parity): focusing the
 * empty field opens popular searches, recently viewed products, bestsellers
 * and popular categories; typing swaps in live SearchWP product results
 * (debounced, min 1 char) with a "view more" link to /shop/?search=….
 * Recently viewed lives in localStorage, seeded by window.phentCurrentProduct
 * on product pages (library/search.php).
 */
const RECENT_KEY = 'phent_recently_viewed';
const RECENT_MAX = 5;

const getRecent = () => {
  try {
    const items = JSON.parse(localStorage.getItem(RECENT_KEY));
    return Array.isArray(items) ? items : [];
  } catch (e) {
    return [];
  }
};

const saveRecent = (items) => {
  try {
    localStorage.setItem(RECENT_KEY, JSON.stringify(items));
  } catch (e) {
    // Storage full/blocked — recently viewed just stays empty.
  }
};

// On a product page, prepend the current product (deduped, capped).
if (window.phentCurrentProduct && window.phentCurrentProduct.id) {
  const current = window.phentCurrentProduct;
  const items = getRecent().filter((p) => p.id !== current.id);
  items.unshift(current);
  saveRecent(items.slice(0, RECENT_MAX));
}

const escapeHtml = (str) =>
  String(str).replace(/[&<>"']/g, (c) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
  }[c]));

// Same row markup as the PHP bestsellers list (search-suggestions.php).
const productItemHtml = (item) => `
  <li>
    <a href="${escapeHtml(item.url)}" class="flex items-center gap-3 px-2.5 py-2 no-underline hover:bg-[#f7f7f7] transition-colors">
      ${item.image ? `<img src="${escapeHtml(item.image)}" alt="" loading="lazy" class="w-10 aspect-[2/3] object-cover rounded flex-shrink-0">` : ''}
      <span class="min-w-0">
        <span class="block font-body font-medium text-[0.8rem] leading-snug text-[#333333] truncate">${escapeHtml(item.name)}</span>
        ${item.category ? `<span class="block font-body text-[0.7rem] leading-snug text-[#999999] truncate">${escapeHtml(item.category)}</span>` : ''}
      </span>
    </a>
  </li>`;

document.querySelectorAll('form[data-live-search]').forEach((form) => {
  const input = form.querySelector('input[type="search"]');
  const panel = form.querySelector('.search-suggestions');
  const ajaxUrl = form.dataset.ajaxUrl;
  const shopUrl = form.dataset.shopUrl || '/';

  if (!input || !panel || !ajaxUrl) {
    return;
  }

  const live = panel.querySelector('.search-suggestions__live');
  const liveList = panel.querySelector('.search-suggestions__live-list');
  const noResults = panel.querySelector('.search-suggestions__no-results');
  const viewMore = panel.querySelector('.search-suggestions__view-more');
  const staticSections = panel.querySelector('.search-suggestions__static');
  const recentSection = panel.querySelector('.search-suggestions__recent');
  const recentList = panel.querySelector('.search-suggestions__recent-list');

  let timer = null;
  let controller = null;
  let pending = 0;

  const setSearching = (delta) => {
    pending = Math.max(0, pending + delta);
    form.classList.toggle('is-searching', pending > 0);
  };

  const renderRecent = () => {
    const items = getRecent();

    if (!items.length || !recentSection || !recentList) {
      return;
    }

    recentList.innerHTML = items.map(productItemHtml).join('');
    recentSection.hidden = false;
  };

  renderRecent();

  const open = () => {
    panel.hidden = false;
  };

  const close = () => {
    panel.hidden = true;
  };

  const showStatic = () => {
    staticSections.hidden = false;
    live.hidden = true;
  };

  const showLive = (items, query) => {
    staticSections.hidden = true;
    live.hidden = false;
    liveList.innerHTML = items.map(productItemHtml).join('');
    noResults.hidden = items.length > 0;

    if (viewMore) {
      viewMore.hidden = items.length < 6;
      viewMore.href = `${shopUrl}?search=${encodeURIComponent(query)}`;
      viewMore.textContent = `Bekijk meer resultaten voor '${query}'`;
    }
  };

  const fetchLive = (query) => {
    if (controller) {
      controller.abort();
    }

    controller = new AbortController();
    setSearching(1);

    fetch(`${ajaxUrl}?action=phent_ajax_search&query=${encodeURIComponent(query)}`, { signal: controller.signal })
      .then((response) => response.json())
      .then((json) => {
        if (json.success) {
          showLive(json.data || [], query);
        }
      })
      .catch(() => {})
      .finally(() => setSearching(-1));
  };

  input.addEventListener('focus', () => {
    open();

    if (!input.value.trim()) {
      showStatic();
    }
  });

  input.addEventListener('input', () => {
    clearTimeout(timer);
    const query = input.value.trim();

    if (!query) {
      showStatic();
      return;
    }

    open();
    timer = setTimeout(() => fetchLive(query), 250);
  });

  // Plain GET of name="search" to the shop page already produces
  // /shop/?search=… — only stop empty submits.
  form.addEventListener('submit', (event) => {
    if (!input.value.trim()) {
      event.preventDefault();
    }
  });

  input.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      close();
      input.blur();
    }
  });

  document.addEventListener('click', (event) => {
    if (!form.contains(event.target)) {
      close();
    }
  });
});
